export const p3pMixins = {

    inject: {
        p3p: {default: null},
        p3pNode: {default: null},
    }
}
